export { default } from "./ResultsPage";
